import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';
import { useContext } from '@nuxtjs/composition-api';
import sendVerifyEmailMutation from '~/mutations/sendVerifyEmail.gql';
import { IBaseGqlResponse } from '~/store/types';
import { InputSize } from '~/types/vuetify';


export default /*#__PURE__*/_defineComponent({
  __name: 'VerifyEmailAddressButton',
  props: {
    buttonColor: { default: 'accentPurple' },
    centered: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    outlined: { type: Boolean, default: false },
    size: { default: 'large' },
    textColor: { default: 'white' }
  },
  emits: ["success", "error"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'success'): void;
  (e: 'error', error: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { buttonColor: string, centered: boolean, disabled: boolean, outlined: boolean, size: InputSize, textColor: string }





const { app, i18n, $sentry, $ua } = useContext();
const isSending = ref(false);
const hasSent = ref(false);
const error = ref('');

const handleClick = async () => {
  try {
    isSending.value = true;
    const response = await sendVerificationEmail();

    if (!response?.data?.sendVerifyEmail?.success) {
      throw new Error('failed to save acceptance');
    }

    isSending.value = false;
    hasSent.value = true;
    // UA tracking
    $ua.trackSendEmailVerificationEmailEvent();
    emit('success');
  } catch (e) {
    $sentry.captureException(error);
    isSending.value = false;
    error.value = i18n
      .t('components.emailVerification.verifyEmailAddress.sendError')
      .toString();
    emit('error', error.value);
  }
};

const sendVerificationEmail = async () =>
  app.apolloProvider?.defaultClient.mutate<IBaseGqlResponse<'sendVerifyEmail'>>(
    {
      mutation: sendVerifyEmailMutation,
      variables: { platform: 'film' },
    },
  );

const heightClasses = computed(() => `fixed-height size--${props.size}`);
const textRowClasses = computed(
  () =>
    `mb-0 fixed-height d-flex align-center ${
      props.centered ? 'justify-center' : 'justify-start'
    }`,
);

return { __sfc: true,props, emit, app, i18n, $sentry, $ua, isSending, hasSent, error, handleClick, sendVerificationEmail, heightClasses, textRowClasses }
}

})